import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    document.addEventListener('stimulus-reflex:before', this.closeOpenModals)
  }

  disconnect() {
    document.removeEventListener('stimulus-reflex:before', this.closeOpenModals)
  }

  closeOpenModals = () => {
    this.element.querySelectorAll('dialog[open]').forEach(d => d.close())
  }

  open(event) {
    const modalId = event.currentTarget.dataset.modalId
    const modal = document.getElementById(modalId)
    if (modal) modal.showModal()
  }

  close(event) {
    const dialog = event.currentTarget.closest('dialog')
    if (dialog) dialog.close()
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      event.currentTarget.close()
    }
  }

  prepareSave(event) {
    const btn = event.currentTarget
    const dialog = btn.closest('dialog')
    btn.dataset.name = dialog.querySelector('[data-field="name"]').value
    btn.dataset.description = dialog.querySelector('[data-field="description"]').value
    btn.dataset.externalSubjectId = dialog.querySelector('[data-field="external_subject_id"]').value
    btn.dataset.externalSubjectIdOwner = dialog.querySelector('[data-field="external_subject_id_owner"]').value
  }
}
